import { Url } from '@wix/da-url';
import { useSelector } from 'react-redux';
import {
  BiData,
  DreamupInfoClickBiEvent,
  RedirectToLoginBiEvent,
} from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { getIsLoggedIn } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { Props as BaseButtonProps } from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink/PlainButtonOrLink';

export type DreamUpButtonProps = Pick<BaseButtonProps, 'href' | 'biData'>;

/** Return the href, biData, and onClick required for a submit button (verification handled) */
export default function useDreamUpButtonProps(): DreamUpButtonProps {
  const isLoggedIn = useSelector(getIsLoggedIn);

  // If logged out, send to sisu with referer to dreamup
  if (!isLoggedIn) {
    const dreamupUrl = Url.dreamupLink();
    const href = `${Url.loginLink()}?referer=${encodeURIComponent(dreamupUrl)}`;

    const biData = BiData<RedirectToLoginBiEvent>({
      evid: 240,
      referral_info: ReferralType.DREAMUP_TOP_CREATE,
    });

    return {
      href,
      biData,
    };
  }

  // Logged in users go directly to dreamup
  const href = Url.dreamupLink();

  const biData = BiData<DreamupInfoClickBiEvent>({
    evid: 923,
    sectionname: 'general',
    typeid: undefined,
    itemid: undefined,
  });

  return {
    href,
    biData,
  };
}
